import React from "react";
import { shallowEqual } from "react-redux";
import styles from "./Summary.module.scss";
import { useCarConfigSelector } from "../../../../../redux/store";
import SummaryRepresentativeExample from "./SummaryRepresentativeExample";
import SummaryIntegratedTradeIn from "./SummaryIntegratedTradeIn";
import { showIntegratedTradeIn } from "../../../../../utils/carConfigSettingsUtils";
import { enableRegistrationTaxSelector } from "../../../../../utils/selectorUtils";
import SummaryTaxAndCosts from "./SummaryTaxAndCosts";
import useAphExternalPriceTaxDisclaimer from "../../../../../hooks/useAphExternalPriceTaxDisclaimer";
import { useTabsContext } from "./SummaryTabsContext";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

const SummaryServices: React.FC = () => {
    const enableRegistrationTax = useCarConfigSelector(enableRegistrationTaxSelector, shallowEqual);
    const showTradeIn = useCarConfigSelector((state) =>
        showIntegratedTradeIn(
            state.carConfigSettings,
            state.commonSettings,
            state.utils.financeOption,
            state.finance.info.productName,
        ),
    );

    const tabsContext = useTabsContext();
    const { visible: wltpTaxVisible } = useAphExternalPriceTaxDisclaimer();

    return (
        <>
            {tabsContext.openTab === "overview" && (
                <Text tag="h2" variant="apheleia-h4" spacing="spacing-1">
                    <CarConfigLabel label="carConfigOtherCostsTitle" />
                </Text>
            )}
            <div className={styles["section-services"]}>
                {!["business"].includes(tabsContext.openTab || "") && (
                    <>
                        {/* Tax and costs section */}
                        {(enableRegistrationTax || wltpTaxVisible) && (
                            <SummaryTaxAndCosts
                                variant={{ registrationTax: enableRegistrationTax, wltpTax: wltpTaxVisible }}
                            />
                        )}

                        {showTradeIn && (
                            <ul role="list" className={styles["config-sublist-services"]}>
                                <SummaryIntegratedTradeIn />
                            </ul>
                        )}
                    </>
                )}

                <SummaryRepresentativeExample hidden={tabsContext.openTab !== "finance"} />
            </div>
        </>
    );
};

export default SummaryServices;
